import { ChatMessage, OrganizationMember } from '@prisma/client'
import { message as messageAntd } from 'antd'
import { useState } from 'react'
import { Toolbox } from '~/plugins/toolbox/shared'
import { useSdk } from '../../../hooks/useSdk'

type Props = {
  organizationMember: OrganizationMember
  onSent: (chatMessage: ChatMessage) => void
}
export const useSendDraft = ({ organizationMember, onSent }: Props) => {
  const [isLoading, setLoading] = useState(false)

  const sdk = useSdk({ organizationMember })

  const send = async (message: ChatMessage) => {
    if (Toolbox.Utility.isNull(message.content)) {
      return
    }

    const contentEnsured = message.content.trim()

    setLoading(true)

    try {
      sdk
        .sendDraft({
          id: message.id,
          content: contentEnsured,
        })
        .then(messageSent => onSent(messageSent))
        .catch(error => {
          console.error(`Could not send message: ${error.message}`)
          messageAntd.error(`Something went wrong`)
        })
    } catch (error) {
      console.error(`Could not send message: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return {
    isLoading,
    send,
  }
}
